import { useEffect, useState } from 'react';
import { Skeleton } from "@mui/material";

import SmallCard from "../../../Components/SmallCard/SmallCard";
import { useFlService } from '../../../Services/FlSubjectService';

import avatar from "../../../images/Avatar_2.svg";
import styles from "./customers.list.module.css";

export default function FlSubjectList({ onClick, onSelect }) {
  const [customers, setCustomers] = useState([]);
  const { getFlSubjects } = useFlService();

  useEffect(() => {
    getFlSubjects().then(result => setCustomers(result.Data))
  }, [])

  return (
    <div className={styles.container}>
      {customers?.length === 0 &&
        [...Array(10)].map((e) =>
          <Skeleton animation="wave" height={60} />
        )
      }
      {customers?.map((x) =>
        <SmallCard
          onClick={() => onClick(x)}
          key={x.id}
          title={`${x.Lastname} ${x.Firstname} ${x.Middlename}`}
          subtitle={`СНИЛС: ${x.Snils}`}
          avatar={avatar}
        />
      )}
    </div>
  )
}